import { render } from "./HomeSectionSix.vue?vue&type=template&id=131fe78f&scoped=true"
import script from "./HomeSectionSix.vue?vue&type=script&lang=js"
export * from "./HomeSectionSix.vue?vue&type=script&lang=js"

import "./HomeSectionSix.vue?vue&type=style&index=0&id=131fe78f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-131fe78f"

export default script